import { GridCellProps } from '@progress/kendo-react-grid'
import { Certificate, Gateway } from './Interfaces'

interface TestCertificateCellProps extends GridCellProps {
  testCertificate: (item: Certificate) => void;
}
interface DeleteCertificateCellProps extends GridCellProps {
  deleteCertificate: (item: Certificate) => void;
}
interface DeleteCertificateCellProps extends GridCellProps {
  deleteCertificate: (item: Certificate) => void;
}

interface DeleteGatewayCellProps extends GridCellProps {
  deleteGateway: (item: Gateway) => void;
}

export const TestCertificateCell = (props: TestCertificateCellProps) => {
    const { dataItem } = props

    return (
        <td className="k-command-cell">
            <div onClick={() => props.testCertificate(dataItem)}>
                <span className="k-icon k-i-video-external"></span>
            </div>
        </td>
    )
}

export const DeleteCertificateCell = (props: DeleteCertificateCellProps) => {
    const { dataItem } = props

    return (
        <td className="k-command-cell">
            <div onClick={() => props.deleteCertificate(dataItem)}>
                <span className="k-icon k-i-trash"></span>
            </div>
        </td>
    )
}

export const DeleteGatewayCell = (props: DeleteGatewayCellProps) => {
    const { dataItem } = props

    return (
        <td className="k-command-cell">
            <div
                onClick={() => props.deleteGateway(dataItem)}
                style={{
                    textAlign: 'center',
                }}
            >
                <span className="k-icon k-i-trash"></span>
            </div>
        </td>
    )
}
